import React from 'react';
import '../../styles/Website/Features.css';

function Features() {
  return (
    <>
      {/* Spreads Section */}
      <section className="spreads-section">
        <div className="container-wide">
          <div className="spreads-grid">
            <div className="spreads-info">
              <h2 className="section-title-large" style={{ color: "#000" }}>Spreads from 0.0 pips</h2>
              <div className="feature-list">
                <div className="feature-item">
                  <span className="check-icon">✓</span>
                  <span>Raw spreads means really from 0.0 pips*</span>
                </div>
                <div className="feature-item">
                  <span className="check-icon">✓</span>
                  <span>Our diverse and proprietary liquidity mix keeps spreads tight 24/5</span>
                </div>
              </div>
              <button className="btn-cta-secondary">Pricing Overview</button>
            </div>
            <div className="spreads-visual">
              <div className="phone-mockup">
                <div className="phone-screen">
                  {/* Mobile trading interface mockup */}
                  <div className="trading-interface">
                    <div className="interface-header">
                      <span className="pair-highlight">HijaAsset Fx</span>
                      <span className="change-positive">0.0 Spread</span>
                    </div>
                    <div className="price-info">
                      <div className="price-row">
                        <span className="label">Script</span>
                        <span className="label">Bid</span>
                        <span className="label">Ask</span>
                        <span className="label">Spread</span>
                      </div>
                      <div className="price-row values">
                        <span>EURUSD</span>
                        <span>1.12009</span>
                        <span>1.12009</span>
                        <span>0.0</span>
                      </div>
                      <div className="price-row values">
                        <span>AUDUSD</span>
                        <span>1.12009</span>
                        <span>1.12009</span>
                        <span>0.0</span>
                      </div>
                      <div className="price-row values">
                        <span>GBPUSD</span>
                        <span>1.12009</span>
                        <span>1.12009</span>
                        <span>0.0</span>
                      </div>
                      <div className="price-row values">
                        <span>XAUUSD</span>
                        <span>1.12009</span>
                        <span>1.12009</span>
                        <span>0.0</span>
                      </div>
                     
                    </div>
                    
                  </div>
                   <div className="dlogo" >
                      <img src="/logo.png" alt="HijaAsset"  style={{ width:'200px', display: 'flex',
  alignItems: 'center'}}/>
                      </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fast Execution & Institutional Trading */}
      <section className="dual-features">
        <div className="container-wide">
          <div className="features-row">
            {/* Fast Order Execution */}
            <div className="feature-block">
              <div className="feature-content-left">
                <h2 className="section-title-large" style={{color: 'black'}}>Fast Order Execution</h2>
                <div className="feature-list">
                  <div className="feature-item">
                    <span className="check-icon">✓</span>
                    <span>Average execution speeds of under 40ms***</span>
                  </div>
                  <div className="feature-item">
                    <span className="check-icon">✓</span>
                    <span>Low latency fibre optic and Equinix NY4 server</span>
                  </div>
                  <div className="feature-item">
                    <span className="check-icon">✓</span>
                    <span>Free Low latency collocated VPS available</span>
                  </div>
                </div>
                <button className="btn-cta-secondary">Get your Free VPS</button>
              </div>
            </div>

            {/* Institutional Grade Trading */}
            <div className="feature-block">
              <div className="feature-content-right">
                <h2 className="section-title-large" style={{color: 'black'}}>Institutional Grade Trading</h2>
                <div className="feature-list">
                  <div className="feature-item">
                    <span className="check-icon">✓</span>
                    <span>Real, deep and diverse liquidity you can trade on</span>
                  </div>
                  <div className="feature-item">
                    <span className="check-icon">✓</span>
                    <span>Reduced slippage</span>
                  </div>
                  <div className="feature-item">
                    <span className="check-icon">✓</span>
                    <span>Over 29 Billion USD in FX trades processed daily</span>
                  </div>
                </div>
                <button className="btn-cta-secondary">Raw Pricing Benefits</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Features;